import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicControlGroup from '../../../../components/BasicControlGroup';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';

const BasicDialog = props => {
  const {
    show,
    proceed,
    cancel,
    dismiss,
    bodyRender,
    bodyStyles,
    textSuccessBtn = 'Ok',
    buttonStyles = {},
    popupStyles,
    popupTitleStyles,
    withoutButtons = false,
    popupInnerStyles,
    modeless,
    dismissWhenClose,
    hasCloseButton,
  } = props;

  const proceedHandler = data => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const buttonStylesProps = {
    btnWidth: buttonStyles.width || 200,
    btnHeight: buttonStyles.height || 35,
    btnFontWeight: buttonStyles.fontWeight || 500,
    btnFontSize: buttonStyles.fontSize || '0.8571rem',
    btnTextColor: buttonStyles.color || '#27282d',
  };

  const bodyRenderWithStyles = <div style={bodyStyles}>{bodyRender}</div>;

  const buttons = (
    <BasicControlGroup
      groupStyles={{ marginRight: 'auto', marginLeft: 'auto' }}
    >
      <BasicButton
        controlFunc={proceedHandler}
        btnWidth={buttonStylesProps.btnWidth}
        btnHeight={buttonStylesProps.btnHeight}
        btnFontWeight={buttonStylesProps.btnFontWeight}
        btnFontSize={buttonStylesProps.btnFontSize}
        btnArrow={false}
        btnTextColor={buttonStylesProps.btnTextColor}
        btnText={textSuccessBtn}
      />
    </BasicControlGroup>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
          cancel,
        }}
        modeless={modeless}
        dismissWhenClose={dismissWhenClose}
        hasCloseButton={hasCloseButton}
        buttonsRender={withoutButtons ? null : buttons}
        compact={withoutButtons}
        bodyRender={bodyStyles ? bodyRenderWithStyles : bodyRender}
        popupStyles={popupStyles}
        popupInnerStyles={popupInnerStyles}
        popupTitleStyles={popupTitleStyles}
      />
    )
  );
};

BasicDialog.propTypes = {
  bodyRender: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  modeless: PropTypes.bool,
  dismissWhenClose: PropTypes.bool,
  textSuccessBtn: PropTypes.string,
  textCancelBtn: PropTypes.string,
  buttonStyles: PropTypes.object,
  popupStyles: PropTypes.object,
  popupInnerStyles: PropTypes.object,
  withoutButtons: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
};

export default createConfirmation(confirmable(BasicDialog));
